import { Box } from '@hover/blueprint';
import React, { useEffect } from 'react';

import { useLogout } from 'src/modules/logout/hooks';
import {
  DelayedLoader,
  ImpersonatorBanner,
  PaymentBannerV1,
} from 'src/shared/components';
import { NavigationBar } from 'src/shared/components/NavBar';
import { PAYMENT_BANNER_EVENT_NAMES } from 'src/shared/components/PaymentBanner/types';
import { useProfileQuery } from 'src/shared/graphql/generated';
import { useCurrentPage } from 'src/shared/hooks';
import { moduleViewed } from 'src/shared/telemetry';

import { AuthenticatedLayout } from './AuthenticatedLayout';

const NavigationLayout = ({ children }: React.PropsWithChildren<{}>) => {
  const { data: profileData } = useProfileQuery();
  const user = profileData?.profile?.user;
  const currentPage = useCurrentPage();
  const [logout, { isPending: isLogoutPending }] = useLogout();
  const bannerDetails = user?.orgs?.[0]?.paymentBanner;

  useEffect(() => {
    if (bannerDetails && currentPage) {
      moduleViewed({
        page_or_screen_name: currentPage,
        feature: `${
          PAYMENT_BANNER_EVENT_NAMES[bannerDetails.kind]
        } credit card banner`,
      });
    }
  }, [bannerDetails, currentPage]);

  return (
    <>
      <ImpersonatorBanner />
      {bannerDetails && <PaymentBannerV1 details={bannerDetails} />}
      <NavigationBar onLogout={logout} />
      <Box flex={1} justifyContent="center">
        {isLogoutPending ? (
          <Box
            alignItems="center"
            height="100vh"
            justifyContent="center"
            minW="100vw"
          >
            <DelayedLoader delay={1000} />
          </Box>
        ) : (
          children
        )}
      </Box>
    </>
  );
};

export const AuthenticatedLayoutWithNavigation = ({
  children,
}: React.PropsWithChildren<{}>) => (
  <AuthenticatedLayout>
    <NavigationLayout>{children}</NavigationLayout>
  </AuthenticatedLayout>
);
